import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '../../components/error/ErrorBoundary';
import { ErrorPage } from '../../components/error/ErrorPage';
import { Index } from '../../features/app';
import { ChakraProvider } from '../../providers/ChakraProvider';

import '../../i18n/config';
import { Layout } from '@/components/layouts/Layout';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <ChakraProvider>
    <ErrorBoundary>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="*" element={<ErrorPage errorCode={404} />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ErrorBoundary>
  </ChakraProvider>
);
